import { AccountsHistoryScreen } from 'pages/Accounts/Screens/AccountsHistoryScreen';
import { AccountsListScreen } from 'pages/Accounts/Screens/AccountsListScreen';

export const routingAccounts = [
  {
    path: '/accounts',
    exact: true,
    component: AccountsListScreen,
    claims: ['CanLookUserSection'],
  },
  {
    path: '/accounts/history/:id',
    exact: true,
    component: AccountsHistoryScreen,
    claims: ['CanEditUser'],
  },
];
